<template>
	<header class="job-listing--item-head">
		<div class="job-listing--item-head-line1">
			<Messages
				:job="job"
				@close="closeMessages"
			/>
			<Appointments
				:job="job"
				@close="$emit('closeAppointments')"
			/>
			<Favorites
				:job="job"
				@load="$emit('loadFavorites')"
			/>
		</div>
		<div class="links-container">
			<span class="matches">
				<template v-if="job.matches > 0">
					<template v-if="isQuestionnaireFinished">
						<span v-if="isPublished" class="color-primary">
							<Icon icon="heart" color="primary"/> {{ matches }}
						</span>
						<span v-else>
							<Icon icon="heart" color="default"/> {{ matches }}
						</span>
					</template>
					<a v-else href="#" @click.prevent="showResultsUnpublished">
						<Icon icon="heart" color="primary"/> {{ matches }}
					</a>
				</template>
				<span v-else>
					<Icon icon="heart"/> {{ matches }}
				</span>
			</span>
			<a
				v-if="isQuestionnaireFinished"
				href="#"
				:class="['status', {'published': isPublished}]"
				@click.prevent="clickedPublishInfo"
			>
				<Icon :icon="isPublished ? 'checkmark' : 'close'"/>
				{{ isPublished ? 'Anonym veröffentlicht' : 'Noch nicht veröffentlicht' }}
			</a>
		</div>
		<PopUp
			v-if="showQuestionnaireHintPopUp"
			size="lg"
			title="Job Matches noch nicht sichtbar"
			cancel-text="Abbrechen"
			ok-text="Frag mich Skilly!"
			@ok="openQuestionnaire"
			@hidden="showQuestionnaireHintPopUp = false"
		>
			<p>Um die Job Matches sehen zu können, benötigen wir noch ein paar mehr Infos von dir.</p>
			<p>Skilly fragt dich gerne noch ein paar Sachen und sagt dir dann Bescheid, wenn du die Matches sehen
				kannst.</p>
		</PopUp>
		<PublishPopUp
			v-if="publish"
			:job="job"
			@hidden="publish = false"
			@publish="onPublish"
		/>
		<UnpublishPopUp
			v-if="unpublish"
			:job="job"
			@hidden="unpublish = false"
			@unpublish="onUnpublish"
		/>
	</header>
</template>

<script>
import Icon from "@/vue/icon/Icon";
import Messages from "./list-item-head/Messages";
import Appointments from "./list-item-head/Appointments";
import Favorites from "./list-item-head/Favorites";
import {PUBLISHED} from "@/helper/job/Status";
import PopUp from "@/vue/common/PopUp";
import PublishPopUp from "@/vue/application/job/PublishPopUp";
import UnpublishPopUp from "@/vue/application/job/UnpublishPopUp";
import EventBus from "@/event/EventBus";
import {MESSAGE_FAN_CLOSED} from "@/event/Event";

/**
 * TODO: adapt bubble counts when something (favorite, appointments, message) change
 */
export default {

	components: {
		Messages,
		Appointments,
		Favorites,
		PopUp,
		Icon,
		PublishPopUp,
		UnpublishPopUp
	},

	props: {
		job: {
			type: Object,
			required: true,
		},
		withName: {
			type: Boolean,
			required: false,
			default: true,
		},
	},

	data ()
	{
		return {
			showQuestionnaireHintPopUp: false,
			publish: false,
			unpublish: false,
		};
	},

	computed: {
		isQuestionnaireFinished ()
		{
			return this.job.questionnaire.finished;
		},
		isPublished ()
		{
			return this.job.status === PUBLISHED;
		},
		matches ()
		{
			return this.job.matches + ' ' + (this.job.matches === 1 ? 'Job Match' : 'Job Matches');
		},
	},

	methods: {
		closeMessages ()
		{
			EventBus.$emit(MESSAGE_FAN_CLOSED, {
				jobId: this.job.id
			});

			this.$emit('closeMessages');
		},
		showResultsUnpublished ()
		{
			this.showQuestionnaireHintPopUp = true;
		},
		clickedPublishInfo ()
		{
			if (!this.isPublished)
			{
				this.publish = true;
				return;
			}

			this.unpublish = true;
		},
		onPublish ()
		{
			this.publish = false;

			this.$emit('publish');
		},
		onUnpublish ()
		{
			this.unpublish = false;

			this.$emit('unpublish');
		},
	}
}
</script>
